import { useEffect } from "react"
import courseService from "../services/courseService"
import { useState } from "react"
import Course from "../components/Home/Course"
import { Tabs, TabsContent, TabsList, TabsTrigger }  from "@radix-ui/react-tabs"
import useAuthStore from "../store/authStore"
import { Frown} from "lucide-react"
import emptyBox from "../assets/images/emtpy-box.webp"
import { stateStore } from "../store/stateStore"
import { Loader } from "../components/ui/loader";


export default function CoursesPage () {
  const [courses,setCourses] = useState(null)
  const [myCourses,setMyCourses] = useState(null)
  const { user} = useAuthStore()
  const { loading} = stateStore()
  const fetchCourses = async () => {
    try {
      if (user) {
        const allCourse = await courseService.getAllCourses()
        const myCourses = await courseService.getMyCourses()
        const myCourseIds = new Set(myCourses.data.map(course => course.id));

        const anotherCourse = allCourse.data.filter(item => !myCourseIds.has(item.id));

        setMyCourses(myCourses.data)
        setCourses(anotherCourse)
      }
      else {
        const allCourse = await courseService.getAllCourses()
        setCourses(allCourse.data)
      }

    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {

    fetchCourses()
  }, [user])
  if (!courses) return null
  return (
    <div className="space-y-4 py-8">
      <h1 className="font-bold text-center text-2xl font-[Phudu]">DANH SÁCH KHÓA HỌC</h1>

      {user ?
        <Tabs defaultValue="my-course" className="w-full">
      <TabsList className="shadow-md py-2 px-8 space-x-4 rounded-lg mb-4 flex justify-center md:justify-normal">
        <TabsTrigger value="my-course"
        className="p-2 rounded-lg data-[state=active]:text-gray-700 data-[state=active]:font-bold data-[state=active]:bg-blue-100">Khóa học của tôi</TabsTrigger>
        <TabsTrigger value="course"
        className="p-2 rounded-lg data-[state=active]:text-gray-700 data-[state=active]:font-bold data-[state=active]:bg-blue-100">Khóa học khác</TabsTrigger>
      </TabsList>

      <TabsContent value="my-course" className="p-8 shadow-md">
        {
        loading ?
        <Loader />
        :
        myCourses &&
          (
          myCourses.length>0 ?
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {

          myCourses.map(course => (
            <Course key={course.id} course={course}/>
          ))

        }
        </div>
        :
        <div className="text-blue-950 font-black text-xl flex justify-center flex-col items-center gap-4">
              <img src={emptyBox} className="size-64"/>
              Bạn chưa đăng ký khóa học nào
        </div>)
      }

      </TabsContent>
      <TabsContent value="course" className="p-8 shadow-md">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {
            courses.map(course => (
              <Course key={course.id} course={course}/>
            ))
          }
        </div>

      </TabsContent>
    </Tabs>
    :
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
    {
      courses.map(course => (
        <Course key={course.id} course={course}/>
      ))
    }
  </div>
  }

    </div>
  )
}
